<template lang="pug">
  div
    .top
      el-button(icon="el-icon-circle-plus-outline"  type="primary"  size="small" @click="openHandler(node)") 新增策略
    .box(v-if="list.length>0")
      auth-group-item(v-for="it in list"  :it="it" :key="it.id"
        @edit="editHandler" @copy="copyHandler" @delete="deleteHandler")
    el-empty(description="暂无数据" v-else )
    auth-group-maintain(ref="maintain" @success="getStrategyAuthList")
</template>

<script>
import AuthGroupMaintain from '@/CommonDP/pages/mainMg/lowcode/metadata/component/metaPage/authGroupMaintain.vue';
import strategyAuthService from '@/CommonDP/service/strategyAuth-service';
import authGroupItem from '@/CommonDP/pages/mainMg/lowcode/metadata/component/metaPage/authGroupItem.vue';
export default {
  name: 'AuthGroup',
  components: { AuthGroupMaintain, authGroupItem },
  props: {},
  data () {
    return {
      node: null,
      list: []
    };
  },
  computed: {},
  watch: {},
  created () {},
  methods: {
    init(node) {
      this.node = node;
      console.log(node);
      this.getStrategyAuthList();
    },
    async getStrategyAuthList() {
      const params = {
        resourceId: this.node.groupId
      };
      const { data } = await strategyAuthService.getStrategyList(params);
      this.list = data;
    },
    openHandler(node, editData = null, type) {
      this.$refs.maintain.open(node, editData, type);
    },
    editHandler(it) {
      this.openHandler(this.node, it);
    },
    copyHandler(it) {
      this.openHandler(this.node, it, 'copy');
    },
    deleteHandler(it) {
      this.$confirm('确认要删除此权限组吗?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async (dialog) => {
        console.log(dialog);
        const data = {
          strategyId: it.strategyId
        };
        await strategyAuthService.strategyDelete(data);
        this.$success('删除成功');
        this.getStrategyAuthList();
      }).catch(err => {
        console.log(err);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.top {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.box {
  overflow: auto;
  height: calc(100vh - 200px);
}
</style>
